<template>
  <div class="  h-full " :style="[hideOverflow]" v-if="initLoad" id="app" >
    <div class=" flex flex-col h-full">

      <div class="sticky top-0 z-50 bg-[#f7f7f7]">
        <div  ref="draggableContainerDiv"  class=" flex h-full items-center justify-center ml-2 mr-2 ">
          <div  :style="draggableContainer">
            <sticky-header v-if="loaded" @clickedToggleDatePicker="openDatePicker" @closeSlideOver="openSlideOver"
                           :dateInformation="dateInformation" :initDateRange="selection">
            </sticky-header>
          </div>
        </div>

      </div>


      <div class=" top-0 right-0 relative z-[60] ">
        <Transition duration="300" name="slideContainer" class="z-[60] right-0">
          <date-range-picker
              @closeDateRangePicker="closeSlideOver($event)"
              @applyDateRangePicker="applyDate($event)"
              v-show="showDatePicker"
              :showDatePicker="showDatePicker"
              :startDate="startDate"
              :endDate="endDate"
              :compareTo="compareTo"
          class="right-0"></date-range-picker>
        </Transition>

        <Transition duration="300" name="slideContainer" class="z-[60] right-0">
            <slide-over
                v-if="showSlideOver"
                :currentWidgets="currentWidgets"
                @closeSlideOver="closeSlideOver($event)"
                @addWidget="addWidget($event)"
                class="slideOver">
            </slide-over>
        </Transition>

      </div>
      <div @click="closeSlideOver($event)"
           v-if="showSlideOver || showDatePicker" class="h-full w-full top-0 left-0 right-0 bottom-0 fixed bg-gray-500 opacity-20 z-50  ">
      </div>

      <div >
        <div  ref="draggableContainerDiv"  class=" flex h-full items-center justify-center ml-2 mr-2 ">
          <div  :style="draggableContainer" class=" pt-3 mb-10">
            <div ref="draggableGrid" class=" mx-auto  draggableGrid">
              <component-widget   ref="ComponentWidgetRef"  @clickedRemove="removeWidget($event)" @clickedMove="moveComponents($event)"
                                  :update="update"
                                  :colorPalette="colorPalette"
                                  v-for="item in widgets"
                                  :widget="item"
                                  :options="showOptions"
                                  :movable="movableComponents"
                                  :style="item.style"
                                  :tabindex="item.tabindex"
                                  :source="item.source"
                                  :name="item.title"
                                  :pills="item.pills"
                                  :widgetType="item.type"
                                  :info="item.info"
                                  :key="item.id"
              ></component-widget>
            </div>
          </div>
        </div>


      </div>
      <sticky-footer @saveChanges="updateMetadata($event)" @hideFooter="closeFooter($event)"  v-if="movableComponents"></sticky-footer>
    </div>
  </div>
  <div v-else  class="flex h-full items-center justify-center">
    <div class="loader loader--style3">
      <svg id="loader-1" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px" width="200px" height="200px" viewBox="0 0 50 50"  xml:space="preserve">
        <path class="loadingSpinner h-20" d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z">
          <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="1s" repeatCount="indefinite"/>
          </path>
        </svg>
    </div>
  </div>
</template>

<script setup>
import ComponentWidget from "@/widgets/ComponentWidget";
import DateRangePicker from "@/components/DateRangePicker";
import StickyFooter from "@/components/StickyFooter";
import StickyHeader from "@/components/StickyHeader"
import {onMounted, ref} from 'vue';
import Draggabilly from "draggabilly";
import Packery from "packery";
import ApiService from "@/services/ApiService";
import SlideOver from "@/components/SlideOver";
let apiService = new ApiService;

let widgets = ref([]);
let loaded = ref(false)
let update = ref(0);
let colorPalette = ref(Object);
let selection = ref();
let startDate = ref()
let endDate = ref()
let compareTo = ref();
let movableComponents = ref(false);
let showOptions = ref(false);
let showDatePicker = ref(false);
let showSlideOver = ref(false);

let draggableGrid = ref(null);
let draggableWidgets = ref([]);
let pckryWidgets = ref([]);
let dateInformation = ref('');
let widgetMap = ref();
let newWidgetOrder = ref([])
let period = ref();
let currentWidgets = ref();
let initLoad = ref(false);
let hideOverflow =ref();
import {useApiStore} from "@/stores/ApiStore";

const apiDataStore = useApiStore();


apiDataStore.$subscribe(getDashboardData, { detached: true});
onMounted(() => {
  initLoad.value = false;
})
const options = ref( { year: 'numeric', month: '2-digit', day: '2-digit' });
let locale = ref();
let draggableContainer = ref(null);
async function getDashboardData(){
  let metaData = null
  await apiService.getMetaData().then( response => {
    colorPalette.value = response.colorPalette;
    metaData = response;
    apiDataStore.setLang(response.lang);
    selection.value = response.selection;
    startDate.value = selection.value.startDate.slice(0,-9)
    endDate.value = selection.value.endDate.slice(0,-9)
    compareTo.value = response.compareTo;
  });
  initLoad.value = true;
  widgets.value = await metaData.widgets;
  apiService.updateDateRange(startDate.value, endDate.value, compareTo.value);
  locale.value = apiDataStore.getLang;
  if (locale.value === 'nl'){
    locale = 'BE-'+locale.value
  }
  let formattedStartDate = new Date(startDate.value).toLocaleDateString(locale.value, options.value)
  let formattedEndDate = new Date(endDate.value).toLocaleDateString(locale.value, options.value)
  dateInformation.value = formattedStartDate + " - " + formattedEndDate
  currentWidgets.value = widgets.value;
  colorPalette.value = await  metaData.colorPalette;
  await configurePackery();
  pckryWidgets.value.layout()
  window.addEventListener('resize', calculateMargins);
  loaded.value = true;
}

async function closeSlideOver() {
  const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
  if (showSlideOver.value) {
    showSlideOver.value = !showSlideOver.value
  }
  if (showDatePicker.value) {
    showDatePicker.value = !showDatePicker.value
  }
  hideOverflow.value = "overflow-x: hidden; overflow-y: hidden; max-width: 100%; height: 200vh"
  await sleep(600)
  hideOverflow.value = " "
}
async function openSlideOver() {
  showSlideOver.value = true
  const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
  hideOverflow.value = "overflow-x: hidden; overflow-y: hidden; max-width: 100%; height: 200vh"
  await sleep(350)
  hideOverflow.value = ""
}
async function openDatePicker() {
  showDatePicker.value = true;
  const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
  hideOverflow.value = "overflow-x: hidden; overflow-y: hidden; max-width: 100%; height: 200vh"
  await sleep(330)
  hideOverflow.value = ""
}


function removeWidget(e) {
  let el = e[0].currentTarget.closest(".grid-item");
  let currWidgets = [];
  currentWidgets.value.forEach(entry => {
    if(entry.type !== e[1].type){
      currWidgets.push(entry)
    }
  })
  currentWidgets.value = currWidgets;
  pckryWidgets.value.remove(el);
  pckryWidgets.value.layout();
  newWidgetOrder.value = [];
  pckryWidgets.value.getItemElements().forEach(function (el) {
      newWidgetOrder.value.push({"name": widgetMap.value.get(el).type})
  })
  updateMetadata();
}

async function addWidget(e) {
  widgets.value = null;
  let widget = await apiService.getWidget(e.handle)
  currentWidgets.value.unshift(widget)
  await setWidgets(currentWidgets.value);
  await configurePackery()
  updateMetadata();
}
async function setWidgets(newWidgets)
{
  widgets.value = newWidgets
}
function updateMetadata()
{
  newWidgetOrder.value = [];
  pckryWidgets.value.getItemElements().forEach(function (el, i){
      newWidgetOrder.value.push({"name": widgetMap.value.get(el).type})
      widgetMap.value.get(el).tabindex = i;
  })
  apiService.postData("/cms/dashboard/metadata", newWidgetOrder.value)
}
function moveComponents(value) {
  movableComponents.value = value;
  showOptions.value = value;
}
function closeFooter(value) {
  movableComponents.value = value;
  showOptions.value = value;
}
function applyDate(value) {
  let startDate = value[0]
  let endDate = value[1]
  let formattedStartDate = new Date(startDate).toLocaleDateString(locale.value, options.value)
  let formattedEndDate = new Date(endDate).toLocaleDateString(locale.value, options.value)
  dateInformation.value = formattedStartDate + " - "+ formattedEndDate
  period.value = value[2];
  update.value += 1;
  let selection = {
    "startDate" : startDate + " 00:00:00",
    "endDate" : endDate + " 00:00:00"
  }
  let daterangeData = {
    "selection": selection,
    "compareTo": period.value
  }
  apiService.postData("/cms/dashboard/metadata/date", daterangeData)
}

function orderItems(){
  widgetMap.value = new Map();
  pckryWidgets.value.items.forEach(function (itemElem, i)
  {
    widgetMap.value.set(pckryWidgets.value.getItemElements()[i],widgets.value[i])
  });
}

function configurePackery()
{
  pckryWidgets.value =  new Packery( draggableGrid.value, {
    itemSelector: ".grid-item",
    gutter: 32,
    columnWidth: 320
  });

  pckryWidgets.value.items.forEach( function( item ) {
    makeItemDraggable( item.element )
  });

  // after dragging
  draggableWidgets.value.forEach(draggie => {
    widgetMap.value = [];
    draggie.on("dragEnd", function () {
      newWidgetOrder.value = [];
      pckryWidgets.value.getItemElements().forEach(function (el){
        newWidgetOrder.value.push({"name": widgetMap.value.get(el).type})
      })
    })
  })

  calculateMargins();
  orderItems();

}
function makeItemDraggable( itemElem ) {
  draggableWidgets.value = []
  let draggie = new Draggabilly( itemElem, { handle: ".handle"});
  draggableWidgets.value.push(draggie)
  pckryWidgets.value.bindDraggabillyEvents( draggie );
}

let draggableContainerDiv = ref(null)
function calculateMargins()
{
  let widthContainer = draggableContainerDiv.value.clientWidth;
  let value = 320;
  while (value <= widthContainer) {
    value += 352;
  }
  value -= 352;
  draggableContainer.value = "width: " + value + "px;";
}
</script>

<style scoped>

.slideContainer-enter-active, .slideContainer-leave-active {
  transition: all 0.3s ease-in-out;
  animation: hide-scroll;
}

.slideContainer-enter-from,
.slideContainer-leave-to {
  transform: translateX(300px);
  opacity: 0;
  animation: hide-scroll;

}
@keyframes hide-scroll {
  0%{
    overflow: hidden;
  }
  100% {
    overflow: hidden;
  }
}

</style>

<!-- SET CUSTOM COLORPALETTE -->
<style>
:root, *, ::before, ::after {
  --barGraphPrimary : v-bind(colorPalette.barGraphPrimary);
  --tw-ring-color : v-bind(colorPalette.pillHover) !important;
  --litepicker-is-in-range-color:  v-bind(colorPalette.dateRange) !important;
  --litepicker-is-start-color-bg: v-bind(colorPalette.dateStartStop) !important;
  --litepicker-is-end-color-bg: v-bind(colorPalette.dateStartStop) !important;
  --border-color: v-bind(colorPalette.pillText) !important;
}
.pillText{
  color: v-bind(colorPalette.pillText);
}
.pillBackground{
  background-color: v-bind(colorPalette.pillBackground);
}
.darkPillBackground{
  background-color: v-bind(colorPalette.darkPillBackground);
}
.moreInfoUrl{
  color: v-bind(colorPalette.moreInfoUrl);
}
.importantText{
  color: v-bind(colorPalette.importantText);
}
.progressBarBackground{
  background-color: v-bind(colorPalette.progressBarBackground);
}
.progressBarText{
  color: v-bind(colorPalette.progressBarText);
}
.loadingSpinner{
  fill: v-bind(colorPalette.loadingSpinner);
}
.headerButtons{
  background-color: v-bind(colorPalette.headerButtons)!important;
}
.borderColor{
  border-color: v-bind(colorPalette.pillHover);
}
.hoverColor :hover{
  color: v-bind(colorPalette.pillHover);
}
</style>